import { IPasswordRecoveryParams } from 'modules/authentication/domain/repositories/IPasswordRecoveriesRepository';
import IPasswordRecoveriesRepository from 'modules/authentication/domain/repositories/IPasswordRecoveriesRepository';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisPasswordRecoveriesRepository
  implements IPasswordRecoveriesRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public create = async ({
    document,
    sendEmail,
    sendSms,
    sendWhatsapp,
  }: IPasswordRecoveryParams): Promise<void> => {
    await this.httpProvider.post('clientes/recuperacaoSenha', {
      numeroCpf: document,
      enviaEmail: sendEmail,
      enviaSms: sendSms,
      enviaWhatsapp: sendWhatsapp,
    });
  };
}
